export type RetirementMessageFromServer = {
  date: string;
  slug: string;
}

export type RetiringData = {
  retiringFamilies: RetirementMessageFromServer[];
  retiringFoundries: RetirementMessageFromServer[];
}

export type CachedRetiringData = {
  retiringFamiliesSlugs: Set<string>;
  retiringFoundriesSlugs: Set<string>;
} & RetiringData;

export type RetirementMessage = {
  href?: string;
  locale?: string;
  name?: string;
} & RetirementMessageFromServer;

export type NotificationOptions = {
  actionLabel?: string;
  actionLink?: string;
  callbackAction?: () => void;
  category?: string;
  queryParams?: string;
  scriptIdentifier?: string;
  skipTimeout?: boolean;
  timeout?: number;
  tooltipText?: string;
}

export type Notification = {
  id: number;
  text: string;
  type: string;
} & NotificationOptions;

export type I18nNotifications = {
  notifications?: {
    retirement_banner?: {
      message?: string;
    };
  };
};

// Event for notification system
export const EVENT_NAME = 'notification-messages-changed';

export interface NotificationMessagesChangedEvent extends CustomEvent {
  detail: {
    messages: Notification[];
    hasMessages: boolean;
  };
}

// Extend the global event map for TypeScript
declare global {
  interface DocumentEventMap {
    [EVENT_NAME]: NotificationMessagesChangedEvent;
  }
}
